import http from 'apis/config/http-service';
import { useCallback } from 'react';

const endpoint = 'suppliers';

type TOption = {
  value: number;
  label: string;
};

interface SupplierRow {
  id: number;
  name: string | null;
}

// Async options for the log-price form's "Current supplier" dropdown — the
// supplier list comes from OUR catalog, searched by name (repo loadOptions
// convention for ChakraAsyncSelect, cf. use-search-bnpl-restaurants-api).
export function useSearchLookupSuppliersApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: TOption[]) => void) => {
    if (inputValue.trim().length < 2) {
      callback([]);
      return;
    }

    http
      .get(endpoint, {
        params: {
          filter: `name||$cont||${inputValue.trim()}`,
          limit: 20,
        },
      })
      .then((res) => {
        const options: TOption[] = (res?.data?.data || []).map((supplier: SupplierRow) => ({
          value: supplier.id,
          label: supplier.name ?? `Supplier #${supplier.id}`,
        }));
        callback(options);
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
